<div class="test-intro">
  <div class="content">
    <img
      class="icon"
      [src]="content?.fields.testIntroIcon.fields.file.url"
      [alt]="content?.fields.testIntroIcon.fields.description || ''"
      loading="lazy"
    />
    <h2 class="title">{{ content?.fields?.testIntroHeading }}</h2>
    <div class="ingress" [innerHTML]="content?.fields.testIntroIngress | richTextToHtml"></div>

    <ng-container *ngIf="content.fields.buttonsWithLinks">
      <div class="test-intro-buttons">
        <a
          [href]="button.fields.link"
          class="test-intro-buttons__button"
          *ngFor="let button of content.fields.buttonsWithLinks"
        >
          <app-picture
            [source]="button.fields.image.fields.file.url"
            [alt]="button.fields.image.fields.description || ''"
            [type]="'banner'"
          >
          </app-picture>
        </a>
      </div>
    </ng-container>

    <p>
      <label class="choose-country__label">{{ content?.fields?.testIntroChooseYourCountry }}</label>
    </p>

    <div class="choose-country__container">
      <app-select-country (changed)="countryChanged($event)" [defaultCountry]="country"></app-select-country>
    </div>

    <form [formGroup]="consentForm">
      <div class="consent" *ngIf="globalContent$ | async as globalContent">
        <input class="consent__input--checkbox" type="checkbox" id="consent" formControlName="consent" />
        <label class="consent__label--checkbox" for="consent">
          {{ globalContent?.fields.dataConsentTextAssets | findResource: 'dataConsent.privacyIsImportant'
          }}<a [routerLink]="content?.fields.startTestConsentLink.fields.link" target="_blank">{{
            content?.fields.startTestConsentLink.fields.title
          }}</a
          >{{ globalContent?.fields.dataConsentTextAssets | findResource: 'dataConsent.dataProcessing' }}
        </label>
      </div>
    </form>

    <div class="cta-container">
      <button type="button" class="cta-link" [disabled]="!consent.value" (click)="startTest()">
        {{ content?.fields.testIntroCtaText }}
      </button>
    </div>
  </div>
</div>
